import { z } from 'zod';

export const DefaultOperator = z.enum([
  'EQUALS',
  'NOT_EQUAL_TO',
  'GREATER_THAN',
  'LESS_THAN',
  'GREATER_THAN_OR_EQUAL_TO',
  'LESS_THAN_OR_EQUAL_TO',
  'CONTAINS',
  'BEGINS_WITH',
  'ENDS_WITH',
  'DOES_NOT_CONTAIN',
  'DOES_NOT_BEGIN_WITH',
  'DOES_NOT_END_WITH',
  'NULL',
  'NOT_NULL',
  'IN',
  'NOT_IN',
  'BETWEEN',
  'NOT_BETWEEN',
  'CONTAINS_ALL',
  'CONTAINS_ANY',
]);
export type DefaultOperator = z.infer<typeof DefaultOperator>;
